function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 18.7336 4.91407 21.2538 6.45324 23.2715L5.63884 28.0001L9.62822 26.1705C11.4746 27.3297 13.659 28 16 28Z",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.2141 16.0462C13.8014 17.247 14.7747 18.2159 15.9781 18.7977C16.0662 18.8394 16.1636 18.8575 16.2607 18.8502C16.3579 18.8428 16.4515 18.8103 16.5322 18.7558L18.3042 17.5742C18.3825 17.522 18.4727 17.4901 18.5665 17.4815C18.6603 17.4729 18.7548 17.4878 18.8413 17.5249L22.1563 18.9456C22.2689 18.9934 22.3629 19.0765 22.4242 19.1825C22.4854 19.2884 22.5106 19.4113 22.4959 19.5328C22.3911 20.3527 21.9911 21.1062 21.3707 21.6524C20.7503 22.1986 19.9521 22.4999 19.1256 22.4999C16.5727 22.4999 14.1244 21.4858 12.3193 19.6807C10.5141 17.8755 9.5 15.4272 9.5 12.8743C9.50004 12.0478 9.80136 11.2496 10.3475 10.6292C10.8937 10.0088 11.6473 9.60881 12.4672 9.50403C12.5886 9.48934 12.7116 9.51451 12.8175 9.57576C12.9234 9.63701 13.0065 9.73103 13.0544 9.84364L14.4763 13.1615C14.5131 13.2473 14.5281 13.3409 14.5199 13.4339C14.5118 13.5269 14.4808 13.6165 14.4296 13.6946L13.2522 15.4937C13.1986 15.5746 13.1669 15.6681 13.1602 15.7649C13.1536 15.8618 13.1721 15.9587 13.2141 16.0462Z",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgWhatsapp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.f327dfd9.svg";
export { ForwardRef as ReactComponent };